(function () {
    const SLIDER = '.vcms-slider';

    function init(slider) {
        if (!slider || slider.__vcmsSliderInit) return;
        slider.__vcmsSliderInit = true;

        const viewport = slider.querySelector('.vcms-slider__viewport') || slider; // Fallback
        const track    = slider.querySelector('.vcms-slider__track');
        const slides   = Array.from(slider.querySelectorAll('.vcms-slider__slide'));
        const btnPrev  = slider.querySelector('.vcms-slider__arrow--prev');
        const btnNext  = slider.querySelector('.vcms-slider__arrow--next');
        const dotsWrap = slider.querySelector('.vcms-slider__dots');

        if (!track || slides.length === 0) return;

        let index = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
        if (index < 0) index = 0;

        const infinite   = (slider.getAttribute('data-infinite') || 'true') === 'true';
        const autoplayMs = parseInt(slider.getAttribute('data-autoplay') || '0', 10);
        let autoplayTimer = null;

        const dots = [];
        if (dotsWrap) {
            dotsWrap.innerHTML = '';
            slides.forEach((_, i) => {
                const b = document.createElement('button');
                b.type = 'button';
                b.setAttribute('aria-label', `Slide ${i+1}`);
                b.addEventListener('click', () => goTo(i));
                dotsWrap.appendChild(b);
                dots.push(b);
            });
        }

        function viewportWidth() { return viewport.clientWidth || slider.clientWidth; }

        function update() {
            const x = -index * viewportWidth();
            track.style.transform = `translate3d(${x}px,0,0)`;
            slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
            dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        }

        function goTo(i) {
            const last = slides.length - 1;
            if (i < 0) i = infinite ? last : 0;
            if (i > last) i = infinite ? 0 : last;
            index = i; update(); restartAutoplay();
        }
        const next = () => goTo(index + 1);
        const prev = () => goTo(index - 1);

        btnNext && btnNext.addEventListener('click', next);
        btnPrev && btnPrev.addEventListener('click', prev);

        viewport.setAttribute('tabindex', '0');
        viewport.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') next();
            if (e.key === 'ArrowLeft')  prev();
        });

        window.addEventListener('resize', update);

        let startX=0, curX=0, dragging=false;
        const threshold = 40;

        const onDown = (x) => { dragging = true; startX = curX = x; track.style.transition = 'none'; };
        const onMove = (x) => {
            if (!dragging) return;
            curX = x;
            const dx = curX - startX;
            track.style.transform = `translate3d(${-index*viewportWidth() + dx}px,0,0)`;
        };
        const onUp = () => {
            if (!dragging) return;
            track.style.transition = '';
            const dx = curX - startX;
            if (dx >  threshold) prev();
            else if (dx < -threshold) next();
            else update();
            dragging = false;
        };

        viewport.addEventListener('pointerdown',  (e) => { e.preventDefault(); onDown(e.clientX); });
        viewport.addEventListener('pointermove',   (e) => onMove(e.clientX));
        viewport.addEventListener('pointerup',     onUp);
        viewport.addEventListener('pointercancel', onUp);
        viewport.addEventListener('pointerleave',  onUp);

        function startAutoplay(){ if (!autoplayMs || autoplayMs < 1000) return; stopAutoplay(); autoplayTimer = setInterval(next, autoplayMs); }
        function stopAutoplay(){ if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
        function restartAutoplay(){ stopAutoplay(); startAutoplay(); }
        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
        slider.addEventListener('focusin',    stopAutoplay);
        slider.addEventListener('focusout',   startAutoplay);

        // Init
        update(); startAutoplay();
    }

    // Auto-init
    function initAll(root=document){ root.querySelectorAll(SLIDER).forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();
})();
